<template>
  <v-container id="depositosbancarios-caplp">
    <v-row class="text-center">
      <v-col cols="12">
        <v-card dark color="success" class="alineacentro DatosMatriculado">
          <v-card-text class="DatosMatriculado">
            <strong>DEPÓSITOS BANCARIOS</strong>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-spacer />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarDeposito" :disabled="!permisoescritura">
                  Confirmar Depósito
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="$router.push('Home')"
                >
                  Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-row class="text-center">
              <v-col cols="12" md="8" lg="8">
                <v-select
                  v-model="deposito.idcuenta"
                  :items="listacuentasbancarias"
                  label="Cuenta Bancaria"
                  item-text="cuenta"
                  item-value="idcuenta"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-text-field
                  v-model="deposito.nrocomprobante"
                  label="N° Comp."
                  type="number"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="8" lg="8">
                <v-text-field
                  v-model="deposito.comentario"
                  label="Comentarios"
                  height="20px"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-select
                  v-model="deposito.idtipodeposito"
                  :items="listatipodepositos"
                  label="Tipo Depósito"
                  item-text="tipodeposito"
                  item-value="idtipodeposito"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="8" lg="8">
                <v-menu
                  v-model="menufdep"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fechalocaldep"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      height="20px"
                      class="ocupa50"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="deposito.fecha"
                    @input="menufdep = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-text-field
                  v-model="deposito.importe"
                  label="Importe"
                  type="number"
                  height="20px"
                />
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12" md="6" lg="6">
                Total de cheques en cartera: {{sumavalorescartera()}}
              </v-col>
              <v-col cols="12" md="6" lg="6">
                Total de cheques depositados: {{sumavaloressel()}}
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-data-table
                  v-model="deposito.chequeseleccionados"
                  :headers="columnascheques"
                  :items="listacheques"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-text': 'Filas por Página:',
                    'items-per-page-all-text': 'Todos',
                  }"
                  item-key="idcheque"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                  multi-sort
                  show-select
                >
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-container>
</template>
<script>
  import axios from "@/axios";
  export default {
    name: "Depositos",
    data() {
      return {
        loading: false,
        usuario: '',
        permisolectura: false,
        permisoescritura: false,
        nromodulo: 30,
        dialogmensaje: false,
        mensajetitulo: '',
        mensajecuerpo: '',
        mensajehome: false,
        menufdep: false,
        deposito: {
          idcuenta: '',
          nrocomprobante: '',
          comentario: '',
          idtipodeposito: '',
          fecha: '',
          importe: 0,
          usuario: '',
          chequeseleccionados: []
        },
        columnascheques: [
          {
            text: "Banco",
            align: "center",
            sortable: true,
            value: "banco",
            width: 200
          },
          {
            text: "N° Cheque",
            align: "center",
            sortable: true,
            value: "numero",
            width: 200
          },
          {
            text: "Fecha",
            align: "center",
            sortable: true,
            value: "fecha",
            width: 110
          },
          {
            text: "F. Venc.",
            align: "center",
            sortable: true,
            value: "vencimiento",
            width: 110
          },
          {
            text: "Importe",
            align: "center",
            sortable: true,
            value: "importe",
            width: 120
          }
        ],
        listacheques: [],
        listacuentasbancarias: [],
        listatipodepositos: [
            {idtipodeposito: 1, tipodeposito: 'PESOS'},
            {idtipodeposito: 2, tipodeposito: 'CHEQUES DE TERCEROS'}
        ]
      }
    },
    mounted() {
      this.loading=true;
      this.usuario= localStorage.getItem('user')
      this.deposito.fecha= this.fechaFormatoVmenu(new Date()); //new Date().toLocaleDateString('en-CA');
      var permisos= JSON.parse(localStorage.getItem('permisos'));
      //var idrol= localStorage.getItem('rolusuario')
      var roles= localStorage.getItem('rolesusuario')
      var existeper=permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario)  && p.idaccion===1);
      if(existeper.length===0)
      {
        this.loading=false;
        this.MostrarMensaje('Error','No tiene permisos para acceder a este módulo.',true);
      }else{
        this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
        this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
        this.CompletaCombos();
      }
    },
    methods: {
      MostrarMensaje(titulo, cuerpo, home) {
        this.mensajetitulo = titulo;
        this.mensajecuerpo = cuerpo;
        this.mensajehome= home!=null ? home : false;
        this.dialogmensaje = true;
      },
      CompletaCombos () {
        this.loading= true;
        axios.get("cuentabancaria").then((result) => {
          this.listacuentasbancarias = result.data;
          this.Limpiar();
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error,false);
        });
      },
      GrabarDeposito () {
        this.loading= true;
        this.deposito.importe= parseFloat(this.deposito.importe);
        //this.deposito.nrocomprobante= parseInt(this.deposito.nrocomprobante);
        if(this.deposito.idcuenta!=null && this.deposito.idcuenta!=''){
          if(this.deposito.nrocomprobante!=null && this.deposito.nrocomprobante!='' && parseInt(this.deposito.nrocomprobante)>0){
            if(this.deposito.fecha!=null && this.deposito.fecha!=''){
              if(this.deposito.importe!=null && this.deposito.importe!='' && parseFloat(this.deposito.importe)>0){
                if((this.deposito.idtipodeposito===1) || (this.deposito.idtipodeposito===2 && parseFloat(this.deposito.importe).toFixed(2)===this.sumavaloressel())){
                  if(this.deposito.nrocomprobante.length<=25){
                    if(this.deposito.comentario.length<=50){
                        this.deposito.usuario= this.usuario;
                        this.deposito.nrocomprobante= this.deposito.nrocomprobante.toString();
                        const deposito = JSON.stringify(this.deposito);
                        axios.post("Banco/PostDeposito", deposito, { headers: {"Content-Type": "application/json"}}).then((result) => {
                          if (result.data == "OK") {
                            this.Limpiar()
                          } else {
                            this.loading = false
                            this.MostrarMensaje("Error", result.data,false)
                          }
                        }).catch((error) => {
                          this.loading = false
                          this.MostrarMensaje("Error", error,false)
                        });
                    }else{
                      this.loading=false;
                      this.MostrarMensaje('Error','Comentario debe ser como máximo de 50 caracteres!!!',false);
                    }
                  }else{
                    this.loading=false;
                    this.MostrarMensaje('Error','N° de Operación debe ser como máximo de 25 cifras!!!',false);
                  }
                }else{
                  this.loading=false;
                  this.MostrarMensaje('Error','El total del depósito no coincide con el total de los valores seleccionados!!!',false);
                }
              }else{
                this.loading=false;
                this.MostrarMensaje('Error','Debe ingresar un importe válido de la operación!!!',false);
              }
            }else{
              this.loading=false;
              this.MostrarMensaje('Error','Debe ingresar la fecha de la operación!!!',false);
            }
          }else{
            this.loading=false;
            this.MostrarMensaje('Error','Debe ingresar el numero de comprobante de la operación!!!',false);
          }
        }else{
          this.loading=false;
          this.MostrarMensaje('Error','Debe seleccionar la cuenta bancaria donde realizo la operación!!!',false);
        }
      },
      sumavaloressel () {
        var sumaval=0;
        var i=0;
        for(i=0;i<this.deposito.chequeseleccionados.length;i++)
        {
            sumaval+= parseFloat(this.deposito.chequeseleccionados[i].importe);
        }
        return parseFloat(sumaval).toFixed(2);
      },
      sumavalorescartera () {
        var sumavalcar=0;
        var i=0;
        for(i=0;i<this.listacheques.length;i++)
        {
            sumavalcar+= parseFloat(this.listacheques[i].importe);
        }
        return parseFloat(sumavalcar).toFixed(2);
      },
      Limpiar () {
        this.loading= true;
        this.deposito= {
          idcuenta: '',
          nrocomprobante: '',
          comentario: '',
          idtipodeposito: '',
          fecha: '',
          importe: 0,
          usuario: '',
          chequeseleccionados: []
        };
        this.listacheques=[];
        axios.get("banco/ListaValores").then((result) => {
           this.listacheques = result.data;
           this.loading=false;
        }).catch((error) => {
           this.loading = false;
           this.MostrarMensaje("Error", error,false);
        });
      },
      fechaFormatoVmenu (date){
        return date.getFullYear() + "-" +((date.getMonth()+1).toString().length != 2 ? "0" + (date.getMonth() + 1) : (date.getMonth()+1)) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate());
      }
    },
    computed: {
      fechalocaldep: function () {
        if(this.deposito.fecha!=null && this.deposito.fecha!='')
        {
          var fecha=new Date(this.deposito.fecha)
          fecha.setDate(fecha.getDate()+1)
          return fecha.toLocaleDateString('es-AR')
        }else{
          return ''
        }
      }
    }
  }
</script>
<style>
  .titulocardchico {
    padding: 8px !important;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa45 {
  width: 45%;
}
.ocupa50 {
  width: 50%;
}
.ocupa60 {
  width: 60%;
}
.ocupa75 {
  width: 75%;
}
.ocupa80 {
  width: 80%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.TituloGrilla2 {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: dimgray;
}
.textoNegritaRojo {
  color:red !important;
  font-weight:bold !important;
}
.textoNegrita {
  font-weight:bold !important;
}
.textoNegritaTitulo {
  font-weight:bold !important;
  font-size: medium;
}
.textoNegritaVerde{
  color:rgb(83, 248, 125) !important;
  font-weight:bold !important;
}
.container {
    max-width: unset !important;
}
</style>